/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sign_Out_OthersInputs */

const th_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ออกจากอุปกรณ์อื่นทั้งหมด (${i?.count})`)
};

const en_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign out all other devices (${i?.count})`)
};

const ja_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`他のすべての端末をサインアウト（${i?.count}）`)
};

const zh_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登出所有其他设备（${i?.count}）`)
};

const es_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerrar sesión en los demás dispositivos (${i?.count})`)
};

const pt_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sair de todos os outros dispositivos (${i?.count})`)
};

const id_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keluarkan semua perangkat lain (${i?.count})`)
};

const fr_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Déconnecter tous les autres appareils (${i?.count})`)
};

const tl_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I-sign out ang lahat ng ibang device (${i?.count})`)
};

const vi_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đăng xuất mọi thiết bị khác (${i?.count})`)
};

const ko_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다른 기기 모두 로그아웃 (${i?.count})`)
};

const de_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle anderen Geräte abmelden (${i?.count})`)
};

const ru_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выйти на всех других устройствах (${i?.count})`)
};

const tr_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diğer tüm cihazları kapat (${i?.count})`)
};

const it_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disconnetti tutti gli altri dispositivi (${i?.count})`)
};

const pl_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wyloguj wszystkie inne urządzenia (${i?.count})`)
};

const uk_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вийти на всіх інших пристроях (${i?.count})`)
};

const hi_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`बाकी सभी उपकरणों से साइन आउट करें (${i?.count})`)
};

const ar_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`إخراج كل الأجهزة الأخرى (${i?.count})`)
};

const ms_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Log keluar semua peranti lain (${i?.count})`)
};

const bn_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`অন্য সব যন্ত্র সাইন আউট করুন (${i?.count})`)
};

const zh_tw2_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登出所有其他裝置（${i?.count}）`)
};

const zh_hk2_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登出所有其他裝置（${i?.count}）`)
};

const ur_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`باقی تمام آلات سائن آؤٹ کریں (${i?.count})`)
};

const fa_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خروج از همهٔ دستگاه‌های دیگر (${i?.count})`)
};

const sw_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toa vifaa vingine vyote (${i?.count})`)
};

const nl_sign_out_others = /** @type {(inputs: Sign_Out_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle andere apparaten uitloggen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Sign out all other devices ({count})" |
*
* @param {Sign_Out_OthersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_out_others = /** @type {((inputs: Sign_Out_OthersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_Out_OthersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_out_others(inputs)
	if (locale === "ja") return ja_sign_out_others(inputs)
	if (locale === "zh") return zh_sign_out_others(inputs)
	if (locale === "es") return es_sign_out_others(inputs)
	if (locale === "pt") return pt_sign_out_others(inputs)
	if (locale === "id") return id_sign_out_others(inputs)
	if (locale === "fr") return fr_sign_out_others(inputs)
	if (locale === "tl") return tl_sign_out_others(inputs)
	if (locale === "vi") return vi_sign_out_others(inputs)
	if (locale === "ko") return ko_sign_out_others(inputs)
	if (locale === "de") return de_sign_out_others(inputs)
	if (locale === "ru") return ru_sign_out_others(inputs)
	if (locale === "tr") return tr_sign_out_others(inputs)
	if (locale === "it") return it_sign_out_others(inputs)
	if (locale === "pl") return pl_sign_out_others(inputs)
	if (locale === "uk") return uk_sign_out_others(inputs)
	if (locale === "hi") return hi_sign_out_others(inputs)
	if (locale === "ar") return ar_sign_out_others(inputs)
	if (locale === "ms") return ms_sign_out_others(inputs)
	if (locale === "bn") return bn_sign_out_others(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_out_others(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_out_others(inputs)
	if (locale === "ur") return ur_sign_out_others(inputs)
	if (locale === "fa") return fa_sign_out_others(inputs)
	if (locale === "sw") return sw_sign_out_others(inputs)
	if (locale === "nl") return nl_sign_out_others(inputs)
	return en_sign_out_others(inputs)
});